/* Veloria — rangées d'images au scroll, texte révélé lettre par lettre,
   coffrets empilés, sceau magnétique */
(() => {
  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const fine = matchMedia("(hover: hover) and (pointer: fine)").matches;
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v));

  /* ---------- Texte : découpe en lettres (mots gardés entiers) */
  const reveals = $$("[data-char-reveal]").map(p => {
    const text = p.textContent.trim().replace(/\s+/g, " ");
    p.setAttribute("aria-label", text);
    p.textContent = "";
    const chars = [];
    text.split(" ").forEach((word, wi, arr) => {
      const w = document.createElement("span");
      w.className = "wd"; w.setAttribute("aria-hidden", "true");
      for (const c of word) {
        const s = document.createElement("span");
        s.className = "ch"; s.textContent = c; w.appendChild(s); chars.push(s);
      }
      p.appendChild(w);
      if (wi < arr.length - 1) p.appendChild(document.createTextNode(" "));
    });
    return { p, chars };
  });
  if (reduce) { reveals.forEach(r => r.chars.forEach(c => c.style.setProperty("--o", 1))); }

  /* ---------- Éléments pilotés par le scroll */
  const rows = $$("[data-img-rows]").map(sec => ({
    sec, tracks: $$(".img-row-track", sec).map((t, i) => ({ t, dir: i === 0 ? 1 : -1 }))
  }));
  const stacks = $$("[data-stack]").map(st => ({ st, cards: $$("[data-stack-card]", st) }));

  function frame() {
    ticking = false;
    const vh = innerHeight;

    // Rangées d'images : sens opposés, boucle infinie
    for (const r of rows) {
      const rect = r.sec.getBoundingClientRect();
      if (rect.bottom < -200 || rect.top > vh + 200) continue;
      const offset = (vh - rect.top) * 0.3;
      for (const { t, dir } of r.tracks) {
        const third = t.scrollWidth / 3 || 1;
        let x = -third + ((dir * offset) % third);
        if (x > 0) x -= third;
        t.style.setProperty("--x", x.toFixed(1) + "px");
      }
    }

    // Texte : chaque lettre s'allume selon la progression
    for (const { p, chars } of reveals) {
      const rect = p.getBoundingClientRect();
      const start = vh * 0.8, end = vh * 0.2;
      const prog = clamp((start - rect.top) / (start - end + rect.height));
      const n = chars.length, lit = prog * n;
      for (let i = 0; i < n; i++) chars[i].style.setProperty("--o", (0.18 + 0.82 * clamp(lit - i)).toFixed(2));
    }

    // Coffrets empilés : les cartes passées rétrécissent légèrement
    for (const { st, cards } of stacks) {
      const rect = st.getBoundingClientRect();
      const total = rect.height - vh;
      const prog = clamp(-rect.top / (total > 0 ? total : 1));
      const n = cards.length;
      cards.forEach((card, i) => {
        const target = 1 - (n - 1 - i) * 0.03;
        const local = clamp((prog - i / n) / (1 - i / n || 1));
        const scale = 1 - (1 - target) * local;
        card.style.transform = `scale(${scale.toFixed(4)})`;
      });
    }
  }
  let ticking = false;
  const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(frame); } };
  if (!reduce) {
    addEventListener("scroll", onScroll, { passive: true });
    addEventListener("resize", onScroll, { passive: true });
    addEventListener("load", onScroll);
    frame();
  }

  /* ---------- Entrée des photos flottantes */
  if ("IntersectionObserver" in window) {
    const io = new IntersectionObserver(es => es.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
    }), { threshold: 0.15 });
    $$(".about-rv").forEach(el => io.observe(el));
  } else { $$(".about-rv").forEach(el => el.classList.add("in")); }

  /* ---------- Sceau magnétique de la bannière */
  if (fine && !reduce) {
    $$(".hero-seal").forEach(el => {
      const pad = 150, strength = 3;
      addEventListener("mousemove", e => {
        const r = el.getBoundingClientRect();
        const cx = r.left + r.width / 2, cy = r.top + r.height / 2;
        const near = Math.abs(cx - e.clientX) < r.width / 2 + pad && Math.abs(cy - e.clientY) < r.height / 2 + pad;
        if (near) {
          el.style.transition = "translate .3s ease-out";
          el.style.translate = `${((e.clientX - cx) / strength).toFixed(1)}px ${((e.clientY - cy) / strength).toFixed(1)}px`;
        } else if (el.style.translate && el.style.translate !== "0px 0px") {
          el.style.transition = "translate .6s ease-in-out";
          el.style.translate = "0px 0px";
        }
      }, { passive: true });
    });
  }
})();
